export default __webpack_public_path__ + "static/media/megane-rs-gallery-7.59ab0a6e.jpg";